import React from 'react';
import { TestimonialCard } from './TestimonialCard';
import { Button } from './Button';
import { QuoteIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  const checkoutUrl = 'https://www.neurotoned.com/offers/6oqdjPAT?coupon_code=7DAYRESETSPECIAL2025';
  const testimonials = [{
    quote: 'Glad to reconnect with these sessions. I was able to get back and grounded in my body after a brain injury. These sessions are great... loved the live group I did last week. Thanks for it being affordable and effective!',
    author: 'Kaye',
    date: '2 weeks ago'
  }, {
    quote: "I have been searching for years about how to get rid of my anxiety. I think I have finally found it in this program. I have completed my first day and I'm looking forward to this healing journey!",
    author: 'Chris',
    date: '1 month ago'
  }, {
    quote: 'Hi! I joined the program 3 days ago, and had two nights of really good sleep after learning the first two exercises. I am impressed how powerful these simple techniques are and the effect they are having in me!',
    author: 'Mari',
    date: '3 weeks ago'
  }];
  const microTestimonials = [{
    quote: 'I finally slept through the night on Day 2.',
    author: 'Jamie K.'
  }, {
    quote: 'That grounding exercise stopped my spiral mid-panic.',
    author: 'Taylor M.'
  }, {
    quote: "I didn't leave my body during a triggering call—huge for me.",
    author: 'Alex P.'
  }];
  return <section className="bg-gradient-to-b from-teal-800 to-teal-700 text-white py-16" data-id="element-330">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-331">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center" data-id="element-332">
          Real Results From Real People Who Already Knew the Science
        </h2>
        <div className="mb-10 max-w-3xl mx-auto" data-id="element-333">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qPKRpbd8Bb7Epcj57bgXpG/11.2.png" alt="Happy Neurotoned users with their journals" className="w-full rounded-lg shadow-xl mb-8" data-id="element-334" />
        </div>
        <div className="mb-10" data-id="element-335">
          <p className="text-lg text-center mb-8" data-id="element-336">
            <strong data-id="element-337">
              You don't need to be convinced the nervous system matters.
            </strong>{' '}
            You need something that actually works.
          </p>
          {/* Micro-testimonials */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-338">
            {microTestimonials.map((testimonial, index) => <div key={index} className="bg-white bg-opacity-10 p-4 rounded-lg" data-id="element-339">
                <div className="flex items-start mb-2" data-id="element-340">
                  <QuoteIcon className="w-5 h-5 text-teal-300 mr-2 flex-shrink-0" data-id="element-341" />
                  <p className="text-lg italic" data-id="element-342">{testimonial.quote}</p>
                </div>
                <p className="text-right text-sm text-teal-200" data-id="element-343">
                  {testimonial.author}
                </p>
              </div>)}
          </div>
          <div className="flex items-center justify-center mb-8" data-id="element-344">
            <div className="flex items-center" data-id="element-345">
              {[...Array(5)].map((_, i) => <svg key={i} className="w-8 h-8 text-[#00b67a] fill-[#00b67a]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" data-id="element-346">
                  <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" data-id="element-347" />
                </svg>)}
            </div>
            <span className="ml-2 text-xl font-semibold text-white" data-id="element-348">
              4.9/5 on Trustpilot
            </span>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8" data-id="element-349">
            {testimonials.map((testimonial, index) => <TestimonialCard key={index} quote={testimonial.quote} author={testimonial.author} date={testimonial.date} data-id="element-350" />)}
          </div>
          <p className="text-center text-lg mb-6" data-id="element-351">
            Already Know The Science? Now You'll Feel the Shift — With Just One
            Week of Daily Body-Based Practice.
          </p>
          <div className="flex justify-center" data-id="element-352">
            <Button link={checkoutUrl} data-id="element-353">Try the 7-Day Reset – Just $9 ➔</Button>
          </div>
        </div>
      </div>
    </section>;
};